(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('TempCustomerSearch', TempCustomerSearch);

    TempCustomerSearch.$inject = ['$resource'];

    function TempCustomerSearch($resource) {
        var resourceUrl =  'api/_search/temp-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
